import { render } from "./SupportUsPage.vue?vue&type=template&id=3b4c0677&scoped=true"
import script from "./SupportUsPage.vue?vue&type=script&lang=js"
export * from "./SupportUsPage.vue?vue&type=script&lang=js"

import "./SupportUsPage.vue?vue&type=style&index=0&id=3b4c0677&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b4c0677"]])

export default __exports__